/**
 * Chevron Icons
 * Simple SVG-based chevron icons for dropdowns and navigation
 */

import React from 'react';

interface ChevronProps {
  size?: number;
  color?: string;
  className?: string;
}

export const IconChevronDown: React.FC<ChevronProps> = ({
  size = 16,
  color = 'currentColor',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M4 6L8 10L12 6'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const IconChevronUp: React.FC<ChevronProps> = ({
  size = 16,
  color = 'currentColor',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M12 10L8 6L4 10'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const IconChevronLeft: React.FC<ChevronProps> = ({
  size = 16,
  color = 'currentColor',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M10 12L6 8L10 4'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const IconChevronRight: React.FC<ChevronProps> = ({
  size = 16,
  color = 'currentColor',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M6 4L10 8L6 12'
        stroke={color}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
